import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { FrameworkPicker } from './FrameworkPicker'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { commonCoreFrameworkAtom, selectedFrameworkAtom } from './atoms'
import {
  CommonCoreJurisdiction,
  useCommonCoreFrameworks,
} from 'domains/scope-and-sequence/hooks'
import { CrosswalkDetails } from './CrosswalkDetails'

const filteredJurisdictions = [CommonCoreJurisdiction]

export function FrameworkDetails() {
  const [ccFramework, setCCFramework] = useAtom(commonCoreFrameworkAtom)
  const [selectedFramework, setSelectedFramework] = useAtom(
    selectedFrameworkAtom,
  )
  const commonCoreFrameworks = useCommonCoreFrameworks()

  useEffect(() => {
    setCCFramework(
      commonCoreFrameworks?.find(
        (f) => f.subject_id === selectedFramework?.subject_id,
      ),
    )
  }, [selectedFramework, commonCoreFrameworks, setCCFramework])

  return (
    <Box>
      <Box>
        <FrameworkPicker
          value={selectedFramework}
          onChange={setSelectedFramework}
          filteredJurisdictions={filteredJurisdictions}
        />
      </Box>
      <Box
        sx={{ pt: 3, pb: 1, fontWeight: 500 }}
      >{`Common Core: ${ccFramework?.name ?? ''}`}</Box>
      <Box paddingTop="16px">
        <CrosswalkDetails />
      </Box>
    </Box>
  )
}
